"use client";

import { useRouter } from "next/navigation";

import isLoggedIn from "@/app/redirect";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import {
  renderLoginComponent,
  checkAndRedirectToLanding,
} from "@/app/(pages)/(prelogin)/(registerlogin)/login/login-utils";

function LoginV1() {
  const { config } = useClientConfigProvider();
  const router = useRouter();
  checkAndRedirectToLanding(config, router);
  return renderLoginComponent(config);
}

export default isLoggedIn(LoginV1);
